export const APP_ENV = process.env.REACT_APP_ENV;
export const HOST_API = process.env.REACT_APP_HOST_API;
export const HOST_API_AUTH = process.env.REACT_APP_HOST_API_AUTH;
export const CLIENTID = process.env.REACT_APP_CLIENTID;
export const HOST_BIZ = process.env.REACT_APP_HOST_BIZ;
export const HOST_BIZ2 = process.env.REACT_APP_HOST_BIZ2;
export const AWS_IMAGE_URL = process.env.REACT_APP_AWS_IMAGE_URL;
export const isDevEnv = APP_ENV === 'development';
export const HOST_UPLOAD_STORAGE_API = process.env.REACT_APP_HOST_UPLOAD_STORAGE_API;
